<script>
</script>
<template>


  <div>
    <NuxtLayout>

      <NuxtPage/>
    </NuxtLayout>

  </div>
</template>